import { useEffect, useMemo, useState } from "react";
import { OTP_MAX_DURATION } from "../utils/constants";

const useOtpResendCountdown = () => {
  const [countDown, setCountDown] = useState(OTP_MAX_DURATION);
  const countdownStop = countDown === 0;
  const countdownStr = useMemo(() => {
    const numToStr = countDown.toString();
    const formatedNum = numToStr.length === 1 ? `0${numToStr}` : numToStr;
    const secString =
      +formatedNum % 60 > 9 ? `${+formatedNum % 60}` : `0${+formatedNum % 60}`;
    return `0${Math.floor(countDown / 60)}: ${secString}`;
  }, [countDown]);

  const handleCountdown = () => {
    setCountDown((prev) => (prev === 0 ? prev : prev - 1));
  };

  const resetTimer = () => setCountDown(OTP_MAX_DURATION);

  useEffect(() => {
    const intervalId = setInterval(handleCountdown, 1000);
    return () => clearInterval(intervalId);
  }, [resetTimer]);

  return { countdownStr, resetTimer, countdownStop };
};

export default useOtpResendCountdown;
